<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="message != undefined"
      :class="{
        opened: opened.indexOf('showMessage') >= 0,
        'last-active': opened.indexOf('showMessage') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="closeBox('showMessage')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>
          <span v-if="message.type == 'up'">{{ $t("zpravaZeZarizeni") }}</span>
          <span v-if="message.type == 'down'">{{ $t("zpravaDoZarizeni") }}</span>
          <span v-if="message">{{ message.custDeviceName }}</span>
        </h2>
      </div>
      <div v-if="message.message" class="side-box__content">
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("datum") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.date(message.messageTime)" />
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("casOdeslani") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.time(message.messageTime)" />
        </div>
        <div v-if="message.type == 'down'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("casOdeslani") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.time(message.messageTime)" />
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("casPrijetiDoNS") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.timestampToTime(message.message.ts)" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("typZpravy") }}</span>
          <span class="side-box__content__value ml-3">
            <span v-if="message.type == 'up'">
              <img class="mr-2" src="@/assets/icons/arrows/ico-ico-zezarizeni.svg" />
              {{ $t("zeZarizeni") }}
            </span>
            <span v-else>
              <img class="mr-2" src="@/assets/icons/arrows/ico-ico-dozarizeni.svg" />
              {{ $t("doZarizeni") }}
            </span>
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("stav") }}</span>
          <span class="side-box__content__value ml-3">
            <span v-if="message.state === 'inFront'" class="atom-tag">{{ $t("veFronte") }}</span>
            <span v-else-if="message.state === 'OK'" class="atom-tag atom-tag--success">OK</span>
            <span v-else class="atom-tag atom-tag--warning">?</span>
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("port") }}</span>
          <span class="side-box__content__value ml-3">
            {{ message.message.port }}
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("nazevZarizeni") }}</span>
          <!--
          <span
            v-if="message.custDeviceName"
            class="side-box__content__value ml-3"
          >
            {{ message.custDeviceName }}
          </span>
          -->
          <span v-if="message.custDeviceName">
            <RouterLink
              :to="{
                name: 'device',
                params: { id: message.deviceId, device: message.device }
              }"
              class="font-weight-bolder link-gray ml-3"
            >
              <span>{{ message.custDeviceName }}</span>
            </RouterLink>
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("idZarizeni") }}</span>
          <span v-if="message.deviceId" class="side-box__content__value ml-3">
            {{ message.deviceId }}
          </span>
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("pocetGateways") }}</span>
          <span v-if="message.message.gws" class="side-box__content__value ml-3">
            {{ message.message.gws.length }}
          </span>
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("baterie") }}</span>
          <span v-if="message.message.bat" class="side-box__content__value ml-3">
            <span v-if="message.message.bat > 0 && message.message.bat < 255" class="d-flex align-items-center">
              <span
                v-if="
                  Math.round((message.message.bat / 254) * 100, 2) < 81 &&
                  Math.round((message.message.bat / 254) * 100, 2) > 60
                "
                class=""
              >
                <span>{{ Math.round((message.message.bat / 254) * 100, 2) }} %</span>
              </span>
              <span
                v-if="
                  Math.round((message.message.bat / 254) * 100, 2) < 61 &&
                  Math.round((message.message.bat / 254) * 100, 2) > 40
                "
                class=""
              >
                <span>{{ Math.round((message.message.bat / 254) * 100, 2) }} %</span>
              </span>
              <span
                v-if="
                  Math.round((message.message.bat / 254) * 100, 2) < 41 &&
                  Math.round((message.message.bat / 254) * 100, 2) > 20
                "
                class=""
              >
                <span>{{ Math.round((message.message.bat / 254) * 100, 2) }} %</span>
              </span>
              <span v-else-if="Math.round((message.message.bat / 254) * 100, 2) < 21" class=" ">
                <span>{{ Math.round((message.message.bat / 254) * 100, 2) }} %</span>
              </span>
              <span v-else-if="message.message.bat == null" class=" ">
                <span>N/A</span>
              </span>
              <div v-else-if="Math.round((message.message.bat / 254) * 100, 2) > 80" class="d-flex align-items-center">
                <span class="">
                  <span>{{ Math.round((message.message.bat / 254) * 100, 2) }} %</span>
                </span>
              </div>
            </span>
            <span v-if="message.message.bat == 0">AC</span>
            <span v-if="message.message.bat == 255">N/A</span>
          </span>
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("silaSignalu") }}</span>
          <span class="side-box__content__value ml-3">
            <span v-if="message.snr < 3 && message.snr >= 0">
              <div class="atom-icon">
                <img src="@/assets/icons/signal/ico/sila-02.svg" />
              </div>
            </span>
            <span v-else-if="message.snr < 0 && message.snr >= -5">
              <div class="atom-icon">
                <img src="@/assets/icons/signal/ico/sila-03.svg" />
              </div>
            </span>
            <span v-else-if="message.snr < -5 && message.snr >= -10">
              <div class="atom-icon">
                <img src="@/assets/icons/signal/ico/sila-04.svg" />
              </div>
            </span>
            <span v-else-if="message.snr < -10 && message.snr != null" class="text-danger">
              <div class="atom-icon">
                <img src="@/assets/icons/signal/ico/sila-05.svg" />
              </div>
            </span>
            <span v-else-if="message.snr >= 3 && message.snr != null">
              <div class="atom-icon">
                <img src="@/assets/icons/signal/ico/sila-01.svg" />
              </div>
            </span>
            <span v-else>N/A</span>
          </span>
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("RSSI") }}</span>
          <span v-if="message.message.gws" class="side-box__content__value ml-3">{{ message.rssi }} dBm</span>
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text">{{ $t("SNR") }}</span>
          <span v-if="message.message.gws" class="side-box__content__value ml-3">{{ message.snr }} dB</span>
        </div>
        <div class="border-top mt-4 pt-4">
          <div class="d-flex justify-content-between">
            <strong class="text-large">{{ $t("obsahZpravy") }}</strong>
            <a @click="exportMessages('xlsx')">{{ $t("stahnoutXLS") }}</a>
          </div>
          <div class="mt-4" style="white-space: pre-wrap">
            {{ makePretty(message.message) }}
          </div>
          <!--div v-for="(line,index) in message.message.split(',')" :key="index+'message'">{{line}}</div-->
        </div>
        <div v-if="loadedDeliveries == false" class="d-flex justify-content-left border-top mt-4 pt-4 pb-4">
          <button class="btn btn-primary" @click="loadDeliveries()">
            {{ $t("nacistDeliveries") }}
          </button>
          <AppLoader v-if="loading" id="deliveriesLoading" class="pl-5 pt-2 pb-2" />
        </div>

        <div
          v-if="loadedDeliveries != false && !oldDeliveries && deliveries.length == 0"
          class="border-top pt-4 mesages__timestamps"
        >
          <div id="deliveries" class="mt-3 mb-3">
            <strong>{{ $t("noDeliveries") }}</strong>
          </div>
        </div>

        <div
          v-if="loadedDeliveries != false && oldDeliveries && deliveries.length == 0"
          class="border-top pt-4 mesages__timestamps"
        >
          <div id="deliveries" class="mt-3 mb-3">
            <strong>{{ $t("noDeliveriesYet") }}</strong>
          </div>
        </div>
        <div
          v-if="loadedDeliveries && !oldDeliveries && deliveries.length > 0"
          class="border-top pt-4 mesages__timestamps"
        >
          <!--
          <div class="d-flex">
            <strong class="text-large">{{ $t("timeStamps") }}</strong>
          </div>-->
          <div id="deliveries" class="mt-3">
            <div class="d-flex">
              <span class="messages__timestamps__col date gray-text">{{ $t("datumACas") }}</span>
              <span class="messages__timestamps__col gray-text">{{ $t("Akce") }}</span>
              <span class="messages__timestamps__col gray-text code">{{ $t("stav") }}</span>
            </div>

            <div class="d-flex messages__timestamps__item">
              <span v-tooltip :title="device.responseTime" class="messages__timestamps__col">
                <span v-html="$filters.timestampToDateTimeMicro(message.message.ts)" />
              </span>

              <span class="messages__timestamps__col">{{ $t("zpravaDorucenaDoPortalu") }}</span>
              <span class="messages__timestamps__col code">
                <span class="atom-tag atom-tag--success">{{ $t("OK") }}</span>
                <!--
                <span
                  v-else
                  v-tooltip
                  v-bind:title="message.error"
                  class="error"
                  >{{ $t("nedoruceno") }}</span
                >
                -->
              </span>
            </div>

            <div v-for="(delivery, index) in deliveriesByTime" :key="index + 'd'">
              <div class="d-flex messages__timestamps__item">
                <span v-tooltip :title="device.responseTime" class="messages__timestamps__col">
                  <span v-html="$filters.dateTimeMicro(delivery.requestTime)" />
                </span>

                <span class="messages__timestamps__col">{{ $t("endpointRequestTime") }}</span>
                <span class="messages__timestamps__col code">
                  <span
                    v-if="delivery.code >= 200 && delivery.code < 300"
                    v-tooltip
                    :title="delivery.code + ' ' + delivery.error"
                    class="atom-tag atom-tag--success"
                  >
                    {{ $t("OK") }}
                  </span>
                  <span v-else>
                    <span class="error">{{ $t("nedoruceno") }}</span>

                    <InfoExclamationMarkNoText :info-tooltip="delivery.code + ' ' + delivery.error" />
                  </span>
                </span>
              </div>

              <div class="d-flex messages__timestamps__item">
                <span v-tooltip :title="device.responseTime" class="messages__timestamps__col">
                  <span v-html="$filters.dateTimeMicro(delivery.responseTime)" />
                </span>

                <span class="messages__timestamps__col">{{ $t("endpointResponseTime") }}</span>
                <span class="messages__timestamps__col code">
                  <span
                    v-if="delivery.code >= 200 && delivery.code < 300"
                    v-tooltip
                    :title="delivery.code + ' ' + delivery.error"
                    class="atom-tag atom-tag--success"
                  >
                    {{ $t("OK") }}
                  </span>
                  <span v-else>
                    <span class="error">{{ $t("nedoruceno") }}</span>
                    <InfoExclamationMarkNoText :info-tooltip="delivery.code + ' ' + delivery.error" />
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!--div v-for="(line,index) in message.message.split(',')" :key="index+'message'">{{line}}</div-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import Loader from "@/components/loader.vue"
import InfoExclamationMarkNoText from "@/components/info/infoExclamationMarkNoText.vue"
export default {
  components: {
    AppLoader: Loader,
    InfoExclamationMarkNoText
  },
  props: {
    device: Object,
    deviceType: String,
    item: Object,
    opened: Array
  },
  data() {
    return {
      message: {},
      loading: false,
      loadedDeliveries: false,
      oldDeliveries: false,
      deliveries: []
    }
  },
  computed: {
    deliveriesByTime() {
      return _.orderBy(this.deliveries, "responseTime", "asc")
    }
  },
  watch: {
    item() {
      this.loadData()
    }
  },
  mounted() {
    this.message = this.item
    this.loadData()
  },
  methods: {
    makePretty: function (value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        //this.errors.group = "";
        this.resetValues()
        this.$emit("closeBox", box)
      }
    },
    setProject() {
      /*this.endpoint.projectId = this.project.projectId;
      this.newGroup.projectId = this.project.projectId;*/
    },
    loadData() {
      this.loading = false
      this.deliveries = []
      this.loadedDeliveries = false
      this.message = {}
      this.message = this.item
    },
    loadDeliveries() {
      this.loading = true
      this.loadedDeliveries = false
      this.oldDeliveries = false
      this.deliveries = []
      let url = ""
      if (this.message.deviceProtocol === "lora") {
        url = `${process.env.VUE_APP_API}/lora/devices/${this.message.deviceId}
                      /up/messages/${this.message.messageId}/deliveries`
      } else {
        url = `${process.env.VUE_APP_API}/mqtt/devices/${this.message.deviceId.replace("mqtt:", "")}
                      /up/messages/${this.message.messageId}/deliveries`
      }
      axios
        .get(url)
        .then((result) => {
          if (result.status == 200) {
            console.log("result", result)

            result.data.data.forEach((delivery) => {
              if (this.message.custDestId == delivery.custDestId) {
                console.log("result match", delivery)
                this.deliveries.push({
                  responseTime: delivery.responseTime,
                  requestTime: delivery.requestTime,
                  code: delivery.code,
                  error: delivery.error
                })
              }
            })
            this.loadedDeliveries = true
            this.loading = false
          }
        })
        .catch((result) => {
          if (result.status == 303) {
            this.loadedDeliveries = true
            this.loading = false
            this.oldDeliveries = true
          }
        })

      /*
      if (this.message.type == "up" && this.deviceType != "endpoint") {
        axios
          .get(
            process.env.VUE_APP_API +
              "/lora/devices/" +
              this.device.deviceId +
              "/up/messages/" +
              this.item.id +
              "/deliveries",
            {
              // headers: {
              //   authorization: "Basic cGl4bWFuOnBpeG1hbg==",
              //   sessionId: this.sessionId
              // }
            }
          )
          .then(result => {
            console.log("result");
            console.log(result);

            result.data.data.forEach(delivery => {
              axios
                .get(
                  process.env.VUE_APP_API +
                    "/http/endpoints/" +
                    delivery.custDestId,
                  {
                    // headers: {
                    //   authorization: "Basic cGl4bWFuOnBpeG1hbg==",
                    //   sessionId: this.sessionId
                    // } 
                  }
                )
                .then(result => {
                  delivery.endpoint = result.data.data;
                  this.deliveries.push(delivery);
                })
                .catch(() => {});
            });
            //let prevObject = this.item;
            //let newObject = result.data.data[0];
            //let merged = {
            //  ...prevObject,
            //  ...newObject
            // }

            //this.deliveries = result.data.data;

            //this.message = merged;
          })
          .catch(() => {});
      } 
      */
    },
    exportMessages(type) {
      // while loop
      let messagesToExport = []
      messagesToExport.push(this.message.message)

      axios
        .post(process.env.VUE_APP_APICMS + "/exportMessages?format=" + type, messagesToExport, {
          responseType: "blob"
        })
        .then((response) => {
          let d = new Date(this.message.message.ts + 2 * 60 * 60 * 1000)
          let dateFrom = d.toISOString()
          let fileNameSuffix =
            "_" +
            this.device.deviceId +
            "_" +
            dateFrom.replaceAll(":", "_").replaceAll("-", "_").replaceAll(".", "_").replaceAll("Z", "")
          if (response.data != undefined) {
            var fileName, blob
            if (type == "csv") {
              fileName = "export" + fileNameSuffix + ".csv"
              blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;"
              })
            } else if (type == "xlsx") {
              fileName = "export" + fileNameSuffix + ".xlsx"
              blob = new Blob([response.data], {
                type: "application/vnd.ms-excel"
              })
            }

            if (window.navigator.msSaveBlob) {
              // FOR IE BROWSER
              navigator.msSaveBlob(blob, fileName)
            } else {
              // FOR OTHER BROWSERS
              var csvUrl = URL.createObjectURL(blob)
              const link = document.createElement("a")
              link.setAttribute("href", csvUrl)
              link.setAttribute("download", fileName)
              link.click()
            }
          }
        })
        .catch(() => {})
    },
    resetValues() {}
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #ef7979;
}
</style>
